const _excluded = ["accountType", "handleToaster"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useState } from 'react';
import ClaimGroupPageContainer from '../containers/ClaimGroupPageContainer';
import { useTranslation } from 'react-i18next';
import claimGroupService from '../../services/claim_group.service';
import ClaimGroupEditFooter from '../../claim_group/edit/ClaimGroupEditFooter';
import { useSetCompanyBreadcrumb } from '../../util/hooks/useSetCompanyBreadcrumb';
export default function AbstractClaimGroupChildPage(_ref) {
  let {
    highlightedMenuItem,
    ClaimGroupChildPage
  } = _ref;
  return function WrappedPage(_ref2) {
    let {
        accountType,
        handleToaster
      } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded);
    const {
      t
    } = useTranslation();
    const [claimGroup, setClaimGroup] = useState(null);
    const [pageIsLoading, setPageIsLoading] = useState(false);
    useSetCompanyBreadcrumb(claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.company, accountType);
    const resetClaimGroup = claimGroupService.useFetchClaimGroupAndUpdateTechnicalReviewState({
      claimGroupId: claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.id,
      setClaimGroup
    });
    const updateClaimGroupCallback = claimGroupService.useUpdateClaimGroup({
      setClaimGroup
    });
    const updateClaimGroup = useCallback(async _ref3 => {
      let {
        updatedClaimGroup = {}
      } = _ref3;
      await updateClaimGroupCallback(_objectSpread(_objectSpread({}, claimGroup), updatedClaimGroup));
    }, [claimGroup, updateClaimGroupCallback]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimGroupPageContainer, {
      highlightedMenuItem: highlightedMenuItem,
      accountType: accountType,
      claimGroup: claimGroup,
      setClaimGroup: setClaimGroup
    }, /*#__PURE__*/React.createElement(ClaimGroupChildPage, _extends({
      accountType: accountType,
      handleToaster: handleToaster,
      claimGroup: claimGroup,
      setClaimGroup: setClaimGroup,
      resetClaimGroup: resetClaimGroup,
      updateClaimGroup: updateClaimGroup,
      pageIsLoading: pageIsLoading,
      setPageIsLoading: setPageIsLoading,
      t: t
    }, props))));
  };
}